import {Dimensions} from '../renderers/canvas-renderer'
import {defaultCellSize} from '../constants-defaults'



export class Grid {
  // contains particle indices per cell
  public particlesPerCell: number[][] = []
  public cellsForParticle: number[][] = []
  public cellSize: number = defaultCellSize
  public dimensions: Dimensions = {width: 1500, height: 1500}
  public cellsX: number
  public cellsY: number
  public nrOfCells: number


  constructor(dimensions: Dimensions, cellSize: number = defaultCellSize) {
    this.cellsX = Math.ceil(dimensions.width / cellSize)
    this.cellsY = Math.ceil(dimensions.height / cellSize)
    this.nrOfCells = this.cellsX * this.cellsY
    this.particlesPerCell = Array.from({length: this.nrOfCells}, () => [])
    this.init(dimensions, cellSize)
  }

  public init(dimensions: Dimensions, maxParticles: number, cellSize: number = defaultCellSize) {
    this.cellSize = cellSize
    this.dimensions = dimensions
    this.cellsForParticle = Array.from({length: maxParticles}, () => [])
  }

  public updateCellsForParticles(particleRadii: Float32Array, posX: Float32Array, posY: Float32Array): void {
    if (posX.length === 0) return
    for (let i = 0; i < posX.length; i++) {
      const oldCells = this.cellsForParticle[i]
      const newCells = this.updateCellsForParticle(i, posX[i], posY[i], particleRadii[i])

      // Entfernen aus alten Zellen
      for (let j = 0; j < oldCells.length; j++) {
        const oldCell = oldCells[j]
        if (oldCell && !newCells.includes(oldCell)) {
          this.particlesPerCell[oldCell].splice(this.particlesPerCell[oldCell].indexOf(i), 1)
        }
      }
      // Hinzufügen zu neuen Zellen
      for (let k = 0; k < newCells.length; k++) {
        const newCell = newCells[k]
        if (newCell && !oldCells.includes(newCell)) {
          this.particlesPerCell[newCell].push(i)
        }
      }

      this.cellsForParticle[i] = newCells
    }
  }


  public updateCellsForParticle(particleIndex: number, particleX: number, particleY: number, particleRadius: number): number[] {
    const {cellSize, dimensions} = this
    const minX = Math.max(0, Math.floor((particleX - particleRadius) / cellSize))
    const maxX = Math.min(Math.ceil((particleX + particleRadius) / cellSize), Math.ceil(dimensions.width / cellSize))
    const minY = Math.max(0, Math.floor((particleY - particleRadius) / cellSize))
    const maxY = Math.min(Math.ceil((particleY + particleRadius) / cellSize), Math.ceil(dimensions.height / cellSize))

    const cellsX = Math.ceil(dimensions.width / cellSize)
    // contains cells for particle

    const cellsForParticle = []
    for (let y = minY; y < maxY; y++) {
      for (let x = minX; x < maxX; x++) {
        const idx = y * cellsX + x
        const cell = this.particlesPerCell[idx]
        if (cell) {
          cellsForParticle.push(idx)
        }
      }
    }
    this.cellsForParticle[particleIndex] = cellsForParticle
    return cellsForParticle
  }
}
